import { render } from "./Copyright.vue?vue&type=template&id=c4f1e33c&scoped=true"
import script from "./Copyright.vue?vue&type=script&lang=js"
export * from "./Copyright.vue?vue&type=script&lang=js"

import "./Copyright.vue?vue&type=style&index=0&id=c4f1e33c&scoped=true&lang=stylus"

import exportComponent from "K:\\ダウンロード\\生活サイト対応\\after\\sei_2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4f1e33c"]])

export default __exports__